import { env } from 'node:process';
import type { WixConfigSchema } from './files/wix.config.js';

export async function importCliSite(config: WixConfigSchema) {
  if (!Object.hasOwn(config, 'siteId')) {
    return null;
  }

  if (env.WIX_CLI_SITE_LIVE === 'true' && Object.hasOwn(config, 'veloAppId')) {
    return import('@wix/cli-site-live');
  }

  if (!Object.hasOwn(config, 'uiVersion')) {
    return import('@wix/cli-site');
  }

  return import('@wix/cli-site-old');
}
